import React from 'react'
export const SwitchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M12 1C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1zm0 20c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9z"
    />
    <path
      className="horizontally"
      fill="currentColor"
      d="M6 11h12v2H6z"
    />
    <path
      className="vertically"
      fill="currentColor"
      d="M13 6v12h-2V6z"
    />
  </svg>
)